/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import { NavLink } from "react-router-dom";

const ConsolseSiteHeader = () => {

    const [showMenu, setShowMenu] = useState<Boolean>(false);
    const { instance } = useMsal();

    async function logoff() {

        /* Using Popup to logoff the current user by using the microsoft popup window */
        await instance.logoutPopup({ mainWindowRedirectUri: process.env.REACT_APP_MSAL_Logoff_RedirectURL });
    }

    return (
        <nav className="navbar navbar-expand-md navbar-dark bg-primary px-4 mb-5">
            <div className="container">
                <NavLink to="/" className="navbar-brand">Unit Costs Administration Console</NavLink>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle text-white" href="#" style={{ fontSize: 20 }} onClick={e => setShowMenu(!showMenu)}>
                            <i className="bi bi-person-circle me-1" />{instance.getActiveAccount()?.username}
                        </a>
                        <ul className={showMenu ? "dropdown-menu show" : "dropdown-menu"}>
                            <li>
                                <a className="dropdown-item" href="#" onClick={logoff}>Logoff</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    )

}

export default ConsolseSiteHeader;